import accountSettingsModule from '../accountSettingsModule';
import displayNameConstants from '../constants/displayNameConstants';

function displayNameController($scope, $uibModal) {
  'ngInject';

  $scope.changeDisplayName = () => {
    const modalUrl = displayNameConstants.changeDisplayNameModal.templateUrl;
    const injectedData = {
      pageData: $scope.accountContent.userInfo.data
    };
    const modalParams = {
      animation: false,
      templateUrl: modalUrl,
      controller: displayNameConstants.changeDisplayNameModal.controllerName,
      resolve: {
        injectedData
      }
    };
    $uibModal.open(modalParams).result.then(
      () => {},
      () => {}
    );
  };
}
accountSettingsModule.controller('displayNameController', displayNameController);

export default displayNameController;
